import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,Label, Input, Container, Button, Modal, Table, UncontrolledTooltip } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import toastr from "toastr";
import { TOAST_OPTIONS, Config } from "helpers/backend_helper";
import "toastr/build/toastr.min.css";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


    const InventorySetup = () => {

        toastr.options = TOAST_OPTIONS;

        const [isEdit, setIsEdit] = useState(false)
        const [isLoading, setIsLoading] = useState(false)
        const [staffList, setStaffList] = useState([])
        const [supplierCategoryList, setSupplierCategoryList] = useState([])
        const [itemCategoryList, setItemCategoryList] = useState([])

        const [regionList, setRegionList] = useState([])
        const [id, setId] = useState('')
        const [itemCategoryName, setItemCategoryName] = useState('')
        const [supplierCategoryName, setSupplierCategoryName] = useState('')
        const [description, setDescription] = useState('')

        const [warehouses, setWareHouses] = useState([])
        const [warehouseId, setWarehouseId] = useState('')
        const [warehouseName, setWarehouseName] = useState('')
        const [warehouseCode, setWarehouseCode] = useState('')
        const [warehouseAddress, setWarehouseAddress] = useState('')
        const [warehousePhone, setWarehousePhone] = useState('')
        const [warehouseRegionId, setWarehouseRegionId] = useState('')
        const [warehouseStatus, setWarehouseStatus] = useState('')
        const [userId, setUserId] = useState('')

        const [modal_warehouse, setmodal_warehouse] = useState(false)
        const [modal_item_category, setmodal_item_category] = useState(false)
        const [modal_supplier_category, setmodal_supplier_category] = useState(false)

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }

        const tog_warehouse = () => {
            setmodal_warehouse(!modal_warehouse);
            removeBodyCss();
        }
        const tog_item_category = () => {
            setmodal_item_category(!modal_item_category);
            removeBodyCss();
        }
        const tog_supplier_category = () => {
            setmodal_supplier_category(!modal_supplier_category);
            removeBodyCss();
        }

        const handleSaveWarehouse = () =>{
            const data = {
                    id: isEdit?warehouseId:'',
                    name: warehouseName,
                    code: warehouseCode,
                    address: warehouseAddress,
                    phone: warehousePhone,
                    regionId: warehouseRegionId,
                    status: warehouseStatus,
                    userId:userId,
                    action: isEdit?'edit':'add'
            }
            setIsLoading(true)
            axios.post(url.WAREHOUSES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                tog_warehouse()
                setIsEdit(false)
                setWarehouseName('')
                setWarehouseCode('')
                setWarehouseAddress('')
                setWarehousePhone('')
                setWarehouseRegionId('')
                setWarehouseStatus('')
                getData()
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const handleDeleteWarehouse = (d) =>{
            const data = {
                    id: d.id,
                    name: '',
                    code: '',
                    address: '',
                    phone: '',
                    regionId: '',
                    status: '',
                    userId:'',
                    action: 'delete'
            }
            setIsLoading(true)
            axios.post(url.WAREHOUSES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                getData()
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const handleSaveSupplierCategory = () =>{
            const data = {
                id: isEdit?id:'',
                name: supplierCategoryName,
                action: isEdit?'edit':'add'
            }
            setIsLoading(true)
            axios.post(url.SUPPLIERCATEGORIES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                setSupplierCategoryName('')
                tog_supplier_category()
                getData()
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const handleDeleteSupplyCategory = (d) =>{
            const data = {
                id: d.id,
                name: 'xxxxx',
                action: 'delete'
            }
            setIsLoading(true)
            axios.post(url.SUPPLIERCATEGORIES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                getData()
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const handleSaveItemCategory = () =>{
            const data = {
                id: isEdit?id:'',
                name: itemCategoryName,
                description: description,
                action: isEdit?'edit':'add'
            }
            setIsLoading(true)
            axios.post(url.ITEMCATEGORIES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                setItemCategoryName('')
                setDescription('')
                tog_item_category()
                getData()
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const handleDeleteItemCategory = (d) =>{
            const data = {
                id: d.id,
                name: 'xxx',
                description: 'xxx',
                action: 'delete'
            }
            setIsLoading(true)
            axios.post(url.ITEMCATEGORIES, JSON.stringify(data), Config).then((r)=>{
                toastr.info(r.data.message)
                getData()
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const getData = () =>{
            axios.get(`${url.REGIONS}`, Config).then((r)=>{
                setRegionList(r.data)
            }).catch((e)=>{console.log(e);})
            axios.get(`${url.SUPPLIERCATEGORIES}`, Config).then((r)=>{
                setSupplierCategoryList(r.data)
            }).catch((e)=>{console.log(e);})
            axios.get(`${url.ITEMCATEGORIES}`, Config).then((r)=>{
                setItemCategoryList(r.data)
            }).catch((e)=>{console.log(e);})
            const data = {}
            axios.post(`${url.USERSFILTER}`, JSON.stringify(data), Config).then((r)=>{
                setStaffList(r.data)
            }).catch((e)=>{console.log(e);})
            axios.get(`${url.WAREHOUSES}`, Config).then((r)=>{
                setWareHouses(r.data)
            }).catch((e)=>{console.log(e);})
            if(localStorage.getItem("authWTUser")){
                const obj = JSON.parse(localStorage.getItem("authWTUser"));
                setUserId(obj.id)
            }  
        }
        useEffect(() => {
           getData() 
        },[]);

        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Inventory Settings | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>


                                <Modal isOpen={modal_warehouse} toggle={() => { tog_warehouse()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Warehouse` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_warehouse(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Warehouse Name</label>
                                                <input type="text" className="form-control" value={warehouseName} onChange={(e)=>setWarehouseName(e.target.value)}    />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Warehouse Code</label>
                                                <input type="text" className="form-control" value={warehouseCode} onChange={(e)=>setWarehouseCode(e.target.value)}    />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Address</label>
                                                <input type="text" className="form-control" value={warehouseAddress} onChange={(e)=>setWarehouseAddress(e.target.value)}    />
                                            </div>
                                        </Col>
                                        {/*}
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Phone</label>
                                                <input type="text" className="form-control" value={warehousePhone} onChange={(e)=>setWarehousePhone(e.target.value)}    />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                        <div className="mb-3">
                                            <label>Umbrella</label>
                                            <select className="form-select" value={warehouseRegionId} onChange={(e)=>setWarehouseRegionId(e.target.value)}>
                                                <option value=""></option>
                                                {regionList.map((r,k)=>(
                                                    <option key={k} value={r.id}>{r.region}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </Col>
                                    */}
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select" value={warehouseStatus} onChange={(e)=>setWarehouseStatus(e.target.value)}>
                                                <option value=""></option>
                                                <option value="Open">Open</option>
                                                <option value="Closed">Closed</option>
                                            </select>
                                        </div>
                                    </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_warehouse() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveWarehouse}  >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_supplier_category} toggle={() => { tog_supplier_category()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` ` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_supplier_category(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Supply Category</label>
                                                <input type="text" className="form-control" value={supplierCategoryName} onChange={(e)=>setSupplierCategoryName(e.target.value)}    />
                                            </div>
                                        </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_supplier_category() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveSupplierCategory}  >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_item_category} toggle={() => { tog_item_category()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` ` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_item_category(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Item Category</label>
                                                <input type="text" className="form-control" value={itemCategoryName} onChange={(e)=>setItemCategoryName(e.target.value)}    />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Description</label>
                                                <input type="text" className="form-control" value={description} onChange={(e)=>setDescription(e.target.value)}    />
                                            </div>
                                        </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_item_category() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveItemCategory}  >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>
                        <div>
                        <Row>
                        <Col xl={6}>
                        
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Warehouses</h5>
                            <CardBody>
                            <Row className="justify-content-center">
                                {((warehouses || []).length > 0)?(
                                    <Col md={12}>
                                    <div className="table-responsive">
                                        <Table className="table table-sm mb-3 table-hover">
                                        <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            {/*<th>Location</th>*/}
                                            <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {(warehouses || []).map((d,k)=>(
                                            <tr key={k}>
                                                <th scope="row">{k+1}</th>
                                                <td>{d.name}</td>
                                                {/*<td>{d.region}</td>*/}
                                                <td  style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                                <div>
                                                    <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={()=>{ setIsEdit(true); tog_warehouse(); setWarehouseId(d.id); setWarehouseName(d.name); setWarehouseCode(d.code); setWarehouseAddress(d.address); setWarehousePhone(d.phone); setWarehouseStatus(d.status); setWarehouseRegionId(d.regionId)}}
                                                    >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">Edit</UncontrolledTooltip>
                                                    </Link>
                                                    <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteWarehouse(d)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                    </Link>
                                                </div>
                                                
                                                </td>
                                            </tr>
                                        ))}
                                            
                                        </tbody>
                                        </Table>
                                    </div>
                                    </Col>
                                ):(
                                    <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Warehouse set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="chat-send w-md btn-sm btn-rounded" onClick={() =>{ tog_warehouse(); setIsEdit(false); setWarehouseId(''); setWarehouseName(''); setWarehouseCode(''); setWarehousePhone(''); setWarehouseRegionId(''); setWarehouseStatus('') }}>
                                        <span className="d-none d-sm-inline-block me-2">Add Warehouse</span></Button>
                                    </div> 
                                </Row>
                                </CardBody>
                            </Card>

                            <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Item category</h5>
                            <CardBody>
                            <Row className="justify-content-center">
                                {((itemCategoryList || []).length > 0)?(
                                    <Col md={12}>
                                    <div className="table-responsive">
                                        <Table className="table table-sm mb-3 table-hover">
                                        <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {(itemCategoryList || []).map((d,k)=>(
                                            <tr key={k}>
                                                <th scope="row">{k+1}</th>
                                                <td>{d.name}</td>
                                                <td  style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                                <div>
                                                    <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={()=>{ setIsEdit(true); tog_item_category(); setId(d.id); setItemCategoryName(d.name); setDescription(d.description) }}
                                                    >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">Edit</UncontrolledTooltip>
                                                    </Link>
                                                    <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteItemCategory(d)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                    </Link>
                                                </div>
                                                
                                                </td>
                                            </tr>
                                        ))}
                                            
                                        </tbody>
                                        </Table>
                                    </div>
                                    </Col>
                                ):(
                                    <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No item category set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="chat-send w-md btn-sm btn-rounded" onClick={() =>{ tog_item_category(); setIsEdit(false); setId(''); setItemCategoryName(''); setDescription('')}}>
                                        <span className="d-none d-sm-inline-block me-2">Add </span></Button>
                                    </div> 
                                </Row>
                                </CardBody>
                            </Card>

                            </Col>
                            <Col xl={6}>

                            <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Supplier Categories</h5>
                            <CardBody>
                            <Row className="justify-content-center">
                                {((supplierCategoryList || []).length > 0)?(
                                    <Col md={12}>
                                    <div className="table-responsive">
                                        <Table className="table table-sm mb-3 table-hover">
                                        <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {(supplierCategoryList || []).map((d,k)=>(
                                            <tr key={k}>
                                                <th scope="row">{k+1}</th>
                                                <td>{d.name}</td>
                                                <td  style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                                <div>
                                                    <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={()=>{ setIsEdit(true); tog_supplier_category(); setId(d.id); setSupplierCategoryName(d.name); }}
                                                    >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">Edit</UncontrolledTooltip>
                                                    </Link>
                                                    <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteSupplyCategory(d)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                    </Link>
                                                </div>
                                                
                                                </td>
                                            </tr>
                                        ))}
                                            
                                        </tbody>
                                        </Table>
                                    </div>
                                    </Col>
                                ):(
                                    <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No supplier category set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                        <Button color="primary" className="chat-send w-md btn-sm btn-rounded" onClick={() =>{ tog_supplier_category(); setIsEdit(false); setId(''); setSupplierCategoryName(''); }}>
                                        <span className="d-none d-sm-inline-block me-2">Add </span></Button>
                                    </div> 
                                </Row>
                                </CardBody>
                            </Card>

                           
                            </Col>
                        </Row>
                        </div>
                    </Container>
                </div>
         
            </>
        );
    }

export default InventorySetup;